import React from 'react';
import { motion } from 'framer-motion';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Legend, Tooltip } from 'recharts';
interface CompetitorGapSlideProps {
  content: {
    headline: string;
    bullets: string[];
    source: string;
    data: Array<{
      category: string;
      average: number;
      top10: number;
    }>;
  };
}
export function CompetitorGapSlide({
  content
}: CompetitorGapSlideProps) {
  return <div className="bg-[#F5F5F5] rounded-2xl p-12 min-h-[600px] flex flex-col relative" data-id="element-95">
      <motion.h2 initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="text-4xl font-bold text-[#1C1C1C] mb-8 text-center" data-id="element-96">
        {content.headline}
      </motion.h2>

      <div className="flex-1 flex gap-12" data-id="element-97">
        {/* Text Area */}
        <div className="w-1/3 flex flex-col justify-center space-y-8" data-id="element-98">
          {content.bullets.map((bullet, index) => {
          const [boldPart, ...rest] = bullet.split(':');
          const isTop10 = boldPart.includes('Top 10%');
          return <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.2 + index * 0.2
          }} className={`p-6 rounded-xl border-l-8 ${isTop10 ? 'bg-[#017C6D]/10 border-[#017C6D]' : 'bg-white border-[#4D4D4D] shadow-sm'}`} data-id="element-99">
                <h3 className={`text-xl font-bold mb-2 ${isTop10 ? 'text-[#017C6D]' : 'text-[#4D4D4D]'}`} data-id="element-100">
                  {boldPart}:
                </h3>
                <p className="text-lg text-[#1C1C1C] leading-relaxed" data-id="element-101">
                  {rest.join(':')}
                </p>
              </motion.div>;
        })}
        </div>

        {/* Chart Area */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.4
      }} className="w-2/3 h-[400px] bg-white p-6 rounded-xl shadow-sm border border-[#4D4D4D]/10" data-id="element-102">
          <ResponsiveContainer width="100%" height="100%" data-id="element-103">
            <BarChart data={content.data} margin={{
            top: 20,
            right: 30,
            left: 0,
            bottom: 0
          }} data-id="element-104">
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" data-id="element-105" />
              <XAxis dataKey="category" tick={{
              fill: '#4D4D4D',
              fontWeight: 600
            }} axisLine={false} tickLine={false} data-id="element-106" />
              <YAxis tickFormatter={val => `${val}%`} tick={{
              fill: '#4D4D4D'
            }} axisLine={false} tickLine={false} data-id="element-107" />
              <Tooltip cursor={{
              fill: '#F5F5F5'
            }} contentStyle={{
              borderRadius: '8px',
              border: 'none',
              boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
            }} formatter={(value: number) => [`${value}%`, 'Adoption Rate']} data-id="element-108" />
              <Legend wrapperStyle={{
              paddingTop: '20px'
            }} data-id="element-109" />
              <Bar dataKey="average" name="Average Contractor" fill="#4D4D4D" radius={[4, 4, 0, 0]} data-id="element-110" />
              <Bar dataKey="top10" name="Top 10% Competitors" fill="#017C6D" radius={[4, 4, 0, 0]} data-id="element-111" />
            </BarChart>
          </ResponsiveContainer>
        </motion.div>
      </div>

      <div className="absolute bottom-6 right-8 text-sm text-[#4D4D4D]/60 font-medium" data-id="element-112">
        {content.source}
      </div>
    </div>;
}
export default CompetitorGapSlide;